/**
 * file-upload theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/file-upload.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { fileUploadAnatomy } from '@chakra-ui/react/anatomy';
export const fileUpload = defineSlotRecipe({
    slots: fileUploadAnatomy.keys(),
    base: {
        dropzone: {
            w: 'full',
            minH: '110px',
            px: '16px',
            py: '16px',
            borderColor: 'text.secondary',
            cursor: 'pointer',
            color: 'text.secondary',
        },
    },
    variants: {
        variant: {
            error: {
                dropzone: {
                    color: 'state.error',
                    borderColor: 'state.error',
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {},
});
